import { FC } from "react";
import {
  SessionItem,
  SessionItemContext,
  SessionItemKind,
} from "@/mds/components/sessions/session-item";
import { SessionPartWithContext, SessionStatus } from "@/mds/components/sessions/session.types";
import { MDSSessionPart } from "@/mds/components/sessions/session-parts/session-part";
import { ThoughtProcessRenderer } from "@/mds/components/sessions/session-item/thought-process/thought-process-renderer";

interface Props {
  data: SessionItem;
  context: SessionItemContext;
}

export const SessionItemContent: FC<Props> = ({ data: item, context }) => {
  if (item.kind === SessionItemKind.ReasoningGroup) {
    const parts = item.data as SessionPartWithContext[];
    const isProcessing = context.status === SessionStatus.Processing;
    const isLastInStack = item.id === context.lastItemId;

    return (
      <ThoughtProcessRenderer
        key={item.id}
        reasoningParts={parts}
        isLastInStack={isLastInStack}
        isProcessing={isProcessing}
        groupId={item.id}
      />
    );
  } else {
    const partWithContext = item.data as SessionPartWithContext;
    return <MDSSessionPart part={partWithContext.part} context={partWithContext.context} />;
  }
};
